(() => {
  if (customElements.get('juc-landing')) return;
  const normalize = value => String(value || '').trim().toLowerCase().replace(/[_-]+/g, ' ').replace(/\s+/g, ' ');
  const colorKey = value => normalize(value).replace(/^matte /, '').replace(/^champagne$/, 'champagne gold');
  const swatches = {gold:'#c7a55c',black:'#252525',silver:'#b9babc','rose gold':'#d7a18b','champagne gold':'#c7ba8e'};
  class JazzUpLanding extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      const configNode = this.querySelector('[data-juc-config]');
      if (!configNode) { queueMicrotask(() => this.connectedCallback()); return; }
      this.initialized = true;
      this.abort = new AbortController();
      this.$ = id => this.querySelector(`[data-juc-id="${id}"]`);
      try { this.config = JSON.parse(configNode.textContent); }
      catch { this.initialized = false; return; }
      this.ui = this.config.ui || {};
      this.money = cents => new Intl.NumberFormat(this.config.locale || 'en', {style:'currency',currency:this.config.currency || 'USD'}).format(cents / 100);
      this.state = {style:'Evalyn', color:'gold', size:'8', image:0};
      this.listen(this, 'click', event => this.handleClick(event));
      this.listen(this.$('knife-pairs'), 'change', () => this.render());
      this.listen(this.$('serving-set'), 'change', () => this.render());
      this.listen(this.$('gallery-track'), 'keydown', event => {
        if (['ArrowLeft','ArrowRight'].includes(event.key)) {event.preventDefault();this.moveImage(this.state.image + (event.key === 'ArrowLeft' ? -1 : 1));}
      });
      this.listen(this.$('gallery-track'), 'scroll', () => {
        clearTimeout(this.scrollTimer);
        this.scrollTimer = setTimeout(() => {
          const track=this.$('gallery-track');
          if (track.clientWidth) this.state.image=Math.max(0,Math.min(this.images.length-1,Math.round(track.scrollLeft/track.clientWidth)));
          this.updateCounter();
        },90);
      });
      this.render();
    }
    disconnectedCallback() {this.abort?.abort();clearTimeout(this.scrollTimer);this.initialized=false;}
    listen(node,type,handler) {node?.addEventListener(type,handler,{signal:this.abort.signal});}
    optionName(option) {return normalize(typeof option==='string'?option:option?.name);}
    optionIndex(product,name) {return product?.options.findIndex(option=>this.optionName(option)===normalize(name)) ?? -1;}
    colorOptionIndex(product) {return this.optionIndex(product,this.config.colorOption);}
    sizeOptionIndex(product) {
      if (!product?.options?.length) return -1;
      const configured=this.optionIndex(product,this.config.sizeOption);
      if (configured>=0) return configured;
      const colorIndex=this.colorOptionIndex(product);
      const looksLikeSize=value=>/\b\d+\s*(?:person|people|pc|pcs|piece|pieces)\b/.test(normalize(value));
      for (let i=0;i<product.options.length;i++) {
        if (i===colorIndex) continue;
        if (product.variants.some(variant=>looksLikeSize(variant.options[i]))) return i;
      }
      for (let i=0;i<product.options.length;i++) {
        if (i!==colorIndex) return i;
      }
      return -1;
    }
    sizeMatches(value,size) {
      const normalized=normalize(value);
      const configured=normalize(this.config.sizes?.[size]);
      if (configured && normalized===configured) return true;
      return new RegExp(`(?:^|\\b)${size}\\s*(?:person|people)\\b`).test(normalized);
    }
    finish(variant,product) {
      const index=this.colorOptionIndex(product);
      return index>=0?colorKey(variant.options[index]):'';
    }
    setVariant(product,color,size) {
      const index=this.sizeOptionIndex(product);
      if (index<0) return null;
      return product.variants.find(variant=>this.finish(variant,product)===color && this.sizeMatches(variant.options[index],size));
    }
    addonVariant(product) {
      return product?.variants.find(variant=>this.finish(variant,product)===this.state.color && variant.available) || null;
    }
    colors(product) {
      const allowed=this.state.style==='Evalyn'?['gold','black','silver']:Object.keys(swatches);
      return allowed.filter(color=>['4','8','12'].some(size=>this.setVariant(product,color,size)?.available));
    }
    handleClick(event) {
      const button=event.target.closest('button');
      if (!button || !this.contains(button) || button.disabled || this.busy) return;
      if (button.dataset.style) {this.state.style=button.dataset.style;this.state.image=0;this.render();}
      else if (button.dataset.color) {this.state.color=button.dataset.color;this.state.image=0;this.render();}
      else if (button.dataset.size) {this.state.size=button.dataset.size;this.render();}
      else if (button.dataset.galleryIndex!==undefined) this.moveImage(Number(button.dataset.galleryIndex));
      else if (button===this.$('gallery-prev')) this.moveImage(this.state.image-1);
      else if (button===this.$('gallery-next')) this.moveImage(this.state.image+1);
      else if (button===this.$('checkout-link')) this.checkout();
    }
    render() {
      const product=this.config.products[this.state.style];
      this.querySelectorAll('[data-style]').forEach(button=>{
        button.disabled=!this.config.products[button.dataset.style];
        button.classList.toggle('active',button.dataset.style===this.state.style);
        button.setAttribute('aria-pressed',String(button.dataset.style===this.state.style));
      });
      if (!product) {
        const other=Object.keys(this.config.products).find(key=>this.config.products[key]);
        if (other) {this.state.style=other;return this.render();}
        this.$('checkout-link').disabled=true;this.$('total').textContent='';this.showError(this.ui.not_configured);return;
      }
      const colors=this.colors(product);
      if (!colors.includes(this.state.color)) this.state.color=colors[0] || 'gold';
      let variant=this.setVariant(product,this.state.color,this.state.size);
      if (!variant?.available) {
        this.state.size=['8','4','12'].find(size=>this.setVariant(product,this.state.color,size)?.available) || '8';
        variant=this.setVariant(product,this.state.color,this.state.size);
      }
      this.variant=variant;
      this.$('checkout-link').disabled=!variant?.available;
      if (!variant?.available) {this.showError(this.ui.no_variants);this.$('total').textContent='';this.$('sticky-price').textContent='';}
      else this.showError('');
      this.$('color-picker').replaceChildren(...colors.map(color=>{
        const button=document.createElement('button');button.type='button';button.className='color-option'+(color===this.state.color?' active':'');button.dataset.color=color;button.setAttribute('aria-pressed',String(color===this.state.color));
        const disc=document.createElement('span');disc.className='color-disc';disc.style.background=swatches[color];
        const label=document.createElement('span');label.textContent=this.colorLabel(product,color);
        button.append(disc,label);return button;
      }));
      const label=this.colorLabel(product,this.state.color);
      this.$('selected-colour').textContent=label;
      this.querySelectorAll('[data-size]').forEach(button=>{
        const size=button.dataset.size,v=this.setVariant(product,this.state.color,size);
        button.disabled=!v?.available;button.classList.toggle('active',size===this.state.size);button.setAttribute('aria-pressed',String(size===this.state.size));
        this.$('price'+size).textContent=v?this.money(v.price):this.ui.unavailable;
        this.$('compare'+size).textContent=v?this.money(v.compare):'';this.$('compare'+size).hidden=!(v?.compare>v?.price);
      });
      this.knives=this.addonVariant(this.config.knives);this.serving=this.addonVariant(this.config.serving);
      const knifeSelect=this.$('knife-pairs');
      knifeSelect.disabled=!this.knives;
      if (!this.knives) knifeSelect.value='0';
      Array.from(knifeSelect.options).forEach(option=>{
        const pairs=Number(option.value);option.textContent=pairs?`${pairs} ${pairs===1?this.ui.pair:this.ui.pairs} · ${this.money((this.knives?.price||0)*pairs)}`:this.ui.no_thanks;
      });
      const servingCheck=this.$('serving-set');servingCheck.disabled=!this.serving;if (!this.serving) servingCheck.checked=false;
      this.querySelector('.addon').hidden=!this.knives;
      this.querySelector('.serving-addon').hidden=!this.serving;
      this.updateAddonImage('knives-image',this.knives,this.config.knives,label+' '+this.ui.steak_knives);
      this.updateAddonImage('serving-image',this.serving,this.config.serving,label+' '+this.ui.serving_set);
      this.$('knives-details').textContent=this.knives?`${this.money(this.knives.price)} ${this.ui.per_pair} · ${label}`:'';
      this.$('serving-price').textContent=this.serving?this.money(this.serving.price):'';
      this.$('serving-compare').textContent=this.serving?this.money(this.serving.compare):'';
      this.$('serving-compare').hidden=!(this.serving?.compare>this.serving?.price);
      const pairs=Number(knifeSelect.value),withServing=servingCheck.checked;
      const subtotal=(variant?.price||0)+pairs*(this.knives?.price||0)+(withServing?this.serving?.price||0:0);
      this.$('summary-title').textContent=`${this.state.style} · ${label} · ${this.state.size} ${this.ui.people}`+(pairs?` + ${pairs*2} ${this.ui.steak_knives}`:'')+(withServing?` + ${this.ui.serving_set}`:'');
      if (variant?.available) {this.$('total').textContent=this.money(subtotal);this.$('sticky-price').textContent=this.ui.selected_set+': '+this.money(subtotal);}
      this.renderGallery(product,variant);
    }
    colorLabel(product,color) {
      const variant=product.variants.find(v=>this.finish(v,product)===color),index=this.optionIndex(product,this.config.colorOption);
      return variant&&index>=0?variant.options[index]:color;
    }
    updateAddonImage(id,variant,product,alt) {
      const image=this.$(id);image.alt=alt;
      const source=variant?.image || (product?.variants.length===1?product.images[0]?.src:null);
      image.hidden=!source;if(source) {image.src=source;image.loading='lazy';}else image.removeAttribute('src');
    }
    galleryImages(product,variant) {
      const override=this.config.galleries.find(g=>g.style===this.state.style&&g.color===this.state.color&&g.images.length);
      if (override) return override.images;
      const ids=product.variants.filter(v=>this.finish(v,product)===this.state.color).map(v=>String(v.id));
      const tagged=product.images.filter(image=>ids.some(id=>image.alt.split(/[^0-9]+/).includes(id)) || normalize(image.alt).split('|').some(tag=>tag===`color:${this.state.color}`)).map(image=>image.src);
      return [...new Set([variant?.image,...tagged].filter(Boolean))];
    }
    renderGallery(product,variant) {
      const images=this.galleryImages(product,variant),key=images.join('|');
      if(this.galleryKey===key) return;
      this.galleryKey=key;this.images=images;this.state.image=0;
      const track=this.$('gallery-track'),thumbs=this.$('gallery-thumbnails');track.replaceChildren();thumbs.replaceChildren();
      images.forEach((src,index)=>{
        const slide=document.createElement('div');slide.className='gallery-slide';slide.setAttribute('role','group');slide.setAttribute('aria-label',`${this.ui.image} ${index+1} ${this.ui.of} ${images.length}`);
        const image=document.createElement('img');image.src=src;image.alt=`${this.state.style} · ${this.colorLabel(product,this.state.color)} · ${index+1}`;image.loading=index?'lazy':'eager';image.draggable=false;image.width=1000;image.height=1000;slide.append(image);track.append(slide);
        const button=document.createElement('button');button.type='button';button.dataset.galleryIndex=index;button.setAttribute('aria-label',`${this.ui.choose_image} ${index+1}`);
        const thumb=image.cloneNode();const url=new URL(src,location.href);url.searchParams.set('width','180');thumb.src=url.href;thumb.alt='';thumb.loading='lazy';button.append(thumb);thumbs.append(button);
      });
      track.scrollTo({left:0,behavior:'instant'});this.updateCounter();
    }
    moveImage(index) {
      if(!this.images?.length)return;
      this.state.image=(index+this.images.length)%this.images.length;
      this.$('gallery-track').scrollTo({left:this.state.image*this.$('gallery-track').clientWidth,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});this.updateCounter();
    }
    updateCounter() {
      this.$('gallery-counter').textContent=this.images?.length?`${this.state.image+1} / ${this.images.length}`:'';
      this.$('gallery-prev').hidden=this.$('gallery-next').hidden=!(this.images?.length>1);
      this.querySelectorAll('[data-gallery-index]').forEach(button=>{const active=Number(button.dataset.galleryIndex)===this.state.image;button.classList.toggle('active',active);button.setAttribute('aria-pressed',String(active));});
    }
    showError(message) {this.querySelector('[data-error]').textContent=message||'';}
    async checkout() {
      if(this.busy||this.added||!this.variant?.available)return;
      this.busy=true;
      const button=this.$('checkout-link'),original=button.innerHTML;button.disabled=true;button.textContent=this.ui.working;this.showError('');
      const items=[{id:this.variant.id,quantity:1}];
      const pairs=Number(this.$('knife-pairs').value);
      if(pairs&&this.knives)items.push({id:this.knives.id,quantity:pairs});
      if(this.$('serving-set').checked&&this.serving)items.push({id:this.serving.id,quantity:1});
      try {
        const response=await fetch(this.config.cartAddUrl,{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},credentials:'same-origin',body:JSON.stringify({items})});
        if(!response.ok)throw new Error('Cart request rejected');
        this.added=true;
        const form=document.createElement('form');form.method='post';form.action=this.config.cartUrl;
        const input=document.createElement('input');input.type='hidden';input.name='checkout';input.value='checkout';form.append(input);this.append(form);form.submit();
      } catch {
        this.showError(this.ui.checkout_error);
        const link=document.createElement('a');link.href=this.config.cartUrl;link.textContent=' '+this.ui.view_cart;this.querySelector('[data-error]').append(link);
        button.innerHTML=original;
        this.querySelectorAll('button,select,input').forEach(control=>control.disabled=true);
      }
    }
  }
  customElements.define('juc-landing',JazzUpLanding);
})();
